<template>
  <div class="ContactUsRequestDemo">
      <navbarv2 />

      <div class="ContactUsRequestDemo__card" style="padding-top: 20px;">
        <!-- <header class="header" style="position: relative;">
			<img src="../../assets/images/homepage/banner_img.jpeg">
            <div class="left-card">
                <div class="sales-title">
                    SIMPLE SALES AND MARKETING SOFTWARE FOR SMALL BUSINESS
                </div>

                <div class="small-slogan">
                    Turn emails into conversations, website visitors into handshakes, and customers into raving fans with all-in one fales & marketing software.
                </div>
            </div>

            <div class="right-card">
                <el-card class="box-card demo-form">
                    <div class="demo-title">SCHEDULE A LIVE DEMO TODAY</div>
                    <el-row :gutter="15" class="mt-4">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin: 5px 0;">
                            <label class="text-sm py-2">NAME</label>
                            <el-input v-model="name" placeholder="Enter your name"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin: 5px 0;">
                            <label class="text-sm py-2">BUSINESS NAME</label>
                            <el-input v-model="business_name" placeholder="Enter your Company name"></el-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15" class="mt-4">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin: 5px 0;">
                            <label class="text-sm py-2">EMAIL</label>
                            <el-input v-model="email" placeholder="Please input"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin: 5px 0;">
                            <label class="text-sm py-2">PHONE NUMBER</label>
                            <vue-tel-input v-model="phone" style="height: 40px;"></vue-tel-input>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15" class="mt-4">
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin: 5px 0;">
                            <label class="text-sm py-2">BUSINESS TYPE</label>
                            <el-select v-model="sector" placeholder="Select nature of business">
                                <el-option
                                label="Food"
                                value="fast_food">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="margin: 5px 0;">
                            <label class="text-sm py-2">YOUR ROLE (OPTIONAL)</label>
                            <el-input v-model="role" placeholder="Please input"></el-input>
                        </el-col>
                    </el-row>
                    <div class="my-6" style="text-align: center;">
                        <el-button class="submit-btn">Request your demo</el-button>
                    </div>
                </el-card>
            </div>
		</header> -->
        <el-row>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <!-- <div class="request-background"></div> -->
                        <div class="banner-img-section">
                            <img src="../../assets/images/request_demo/requestdemo.jpg">
                            <div class="text-desc">
                                Modernize your business with NymbleUp’s comprehensive solution
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <div class="demo-descp-section">
                            <div class="title" style="margin-left: 30px;">
                                Our demo will -
                            </div>
                            <div>
                                <div class="points" v-for="(item, item_index) in desciption_list" :key="item_index">
                                    <div>
                                        <img src="../../assets/images/request_demo/checkmark.png" style="height: 20px;">
                                    </div>
                                    <div style="margin-left: 15px;">{{ item.title }}</div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="demo-form">
                    <div class="demo-title">Fill out the form to learn how NymbleUp’s solution can help your business</div>

                    <div class="mt-2">
                        <label class="text-sm py-2">Name <span style="color: red;">*</span></label>
                        <el-input v-model="name" placeholder="Enter your full name" v-validate="'required'" name="Name"></el-input>
                        <span class="text-red-dark text-xs">
                            {{ errors.first("Name") }}
                        </span>
                    </div>
                    <div class="mt-2">
                        <label class="text-sm py-2">Company Name <span style="color: red;">*</span></label>
                        <el-input v-model="company_name" placeholder="Enter your Company name" v-validate="'required'" name="Company name"></el-input>
                        <span class="text-red-dark text-xs">
                            {{ errors.first("Company name") }}
                        </span>
                    </div>
                    <div class="mt-2">
                        <label class="text-sm py-2">Email <span style="color: red;">*</span></label>
                        <el-input v-model="email" placeholder="Enter your email address" v-validate="'required'" name="Email"></el-input>
                        <span class="text-red-dark text-xs">
                            {{ errors.first("Email") }}
                        </span>
                    </div>
                    <div class="mt-2">
                        <label class="text-sm py-2">Phone Number <span style="color: red;">*</span></label>
                        <vue-tel-input v-model="phone" style="height: 40px;" v-validate="'required'" name="Phone number"></vue-tel-input>
                        <span class="text-red-dark text-xs">
                            {{ errors.first("Phone number") }}
                        </span>
                    </div>

                    <div class="mt-6 mb-2" style="text-align: center;">
                        <el-button class="submit-btn" :loading="form_submit_progress" @click="submit()">REQUEST DEMO</el-button>
                    </div>
                    <div style="font-size: 12px; color: #000; text-align: center;">By sumbitting this form you agreee to NymbleUp’s <span style="color: #409eff; cursor-pointer;" @click="$router.push({ path: '/terms-of-service' }).catch(()=>{})">terms</span></div>
                </div>
            </el-col>
        </el-row>
      </div>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import { serverAddr } from "../../networkConfig.js";
export default {
    name: "ContactUsRequestDemo",
    components: {
        VueTelInput
    },
    data() {
        return {
            name: "",
            company_name: "",
            phone: "",
            email: "",
            form_submit_progress: false,
            desciption_list: [
                {
                    title: 'Walk you through NymbleUp’s Workforce Planning and Demand management solutions'
                },
                {
                    title: 'Help you understand what planning looks like with NymbleUp'
                },
                {
                    title: "Explore how NymbleUp can adapt to your company's systems"
                },
                {
                    title: 'Get you started with pilot at your company'
                }
            ]
        }
    },
    methods: {
        submit() {
            this.$validator.validateAll().then(result => {
				if (result) {
                    this.form_submit_progress = true;     //enabled loader

                    serverAddr.post("/company/contact-us/", {
                        name: this.name,
                        business_name: this.company_name,
                        phone: this.phone,
                        email: this.email,
                        sector: this.sector,
                        role: this.role
                    }).then(res => {
                        this.form_submit_progress = false;      //disabled loader

                        this.$notify.success({
                            title: "Sucess",
                            message: 'Request submitted',
                            type: "success"
                        });
                    })
                    .catch(err => {
                        console.log(err);
                        this.form_submit_progress = false;      //disabled loader
                    })
                }
            })
        }
    }

}
</script>

<style lang="scss" scoped>
    .ContactUsRequestDemo{
        .submit-btn{
            background-color: #e29d5a;
            border-color: #e29d5a;
            font-weight: bold;
            color: #fff;
            width: 50%;
        }
        .header {
            height: 100vh;
            width: 100%;
            background: black;
            overflow: hidden;
            img {
                object-fit: cover;
                opacity: 0.4;
                height: 100%;
                width: 100%;
            }
            .left-card{
                position: absolute; top: 25%; left: 30px;
            }
            .right-card{
                position: absolute; top: 20%; right: 30px; margin: 0 0 0 30px;
            }
            .sales-title{
                font-size: 32px;
                font-weight: 600;
                color: #fff;
                max-width: 500px;
                line-height: 2;
            }
            .small-slogan{
                font-size: 15px;
                color: #fff;
                max-width: 500px;
                line-height: 1.6;
            }
        }
        .demo-form{
            width: 70%;
            margin: 60px auto 0 auto;
            padding: 20px;
            // text-align: center;
            .demo-title{
                font-size: 18px;
                color: #000;
                font-weight: 600;
                line-height: 1.5;
            }
            label{
                display: block;
                font-weight: 500;
                font-size: 11px;
                color: #000;
            }
        }

        .banner-img-section{
            background-color: #000;
            height: 50vh;
            width: 50vw;
            position: relative;
            img{
                height: 100%;
                width: 100%;
                opacity: 0.6;
            }
            .text-desc{
                position: absolute;
                bottom: 15px;
                left: 30px;
                color: #fff;
                letter-spacing: 1px;
                line-height: 1.5;
                font-size: 1.8rem;
                font-weight: 700;
            }
        }

        .demo-descp-section{
            background-color: #e29d5a;
            min-height: 50vh;
            width: 50vw;
            padding: 25px 20px;
            .title{
                font-size: 1.2rem;
                color: #fff;
                font-weight: 700;
            }
            .points{
                display: flex;
                align-items: center;
                color: #fff;
                margin-top: 25px;
                font-size: 15px;
            }
        }


        .request-background{
            background-image: url('../../assets/images/request_demo/requestdemo.jpg');
            height: 50vh;
            background-repeat: no-repeat;
            // background-size: cover;
            // background-position: center 50%;
            margin-top: 60px;
        }

        @media screen and (max-width: 992px) {
            .banner-img-section{
                height: 50vh;
                width: 100vw;
            }
            .demo-descp-section{
                height: 50vh;
                width: 100vw;
            }
        }

        @media screen and (max-width: 768px) {
            .demo-form{
                margin: 20px auto 0 auto;
            }
        }
        @media screen and (max-width: 600px) {
            .demo-form{
                width: 95%;
            }
        }
    }
</style>
<style lang="scss">
.ContactUsRequestDemo{
    input::placeholder{
        font-size: 12px;
    }
}
</style>
